<template>
  <transition name="popover-fade">
    <div ref="options" class="k-popover" v-if="showPopover">
      <div class="scroll-wrap" id="scroll-wrap">
        <ul class="k-ul" id="k-ul">
          <li
            v-for="item in val"
            :class="{on: item.id === selected.id}"
            :key="item.id"
            @click="selectOption(item)"
          >{{item.val}}</li>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: "k-option",
  props: ["val", "pos", "size", "selected"],
  data() {
    return {
      showPopover: false
    };
  },
  methods: {
    computeStyle() {
      /**
       * 初始化popover的宽度和位置
       */
      var popover = this.$refs.options;
      popover.style.width = this.size.width + "px";
      popover.style.top = this.pos.top + this.size.height + 10 + "px";
      popover.style.left = this.pos.left + "px";
      document.body.appendChild(popover);
      /**
       * 修改scroll-wrap的样式以清除滚动框
       */
      this.$nextTick(function() {
        var scrollWrap = document.getElementById("scroll-wrap"),
          kUl = document.getElementById("k-ul");
        scrollWrap.style.marginRight =
          kUl.offsetWidth - scrollWrap.offsetWidth + "px";
        scrollWrap.style.marginBottom =
          kUl.offsetWidth - scrollWrap.offsetWidth + "px";
      });
    },
    changeDom() {
      this.$refs.options.style.width = this.size.width + "px";
      this.$refs.options.style.top =
        this.pos.top + this.size.height + 10 + "px";
      this.$refs.options.style.left = this.pos.left + "px";
    },
    attachClick() {
      var vm = this;
      document.body.addEventListener("click", vm.handleClose);
    },
    removeClick() {
      var vm = this;
      document.body.removeEventListener("click", vm.handleClose);
    },
    handleClose(e) {
      var cName = e.target.parentNode.className;
      if (
        cName !== "k-ul" &&
        cName !== "scroll-wrap" &&
        cName !== "k-popover"
      ) {
        this.$emit("closePopover");
      }
    },
    selectOption(item) {
      this.$emit("closePopover", item);
    }
  },
  created() {
    this.showPopover = true;
  },
  mounted() {
    this.computeStyle();
    this.attachClick();
  },
  beforeDestory() {
    
    this.removeClick();
  }
};
</script>

<style lang="scss">
.k-popover {
  position: absolute;
  top: 0;
  left: 0;
  max-height: 274px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  overflow: hidden;
}
.scroll-wrap {
  max-height: 274px;
  overflow: scroll;
}
.k-ul {
  margin: 0;
  padding: 0;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  li {
    position: relative;
    padding: 0 20px;
    height: 34px;
    color: #606266;
    line-height: 34px;
    font-size: 14px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    list-style-type: none;
    box-sizing: border-box;
    cursor: pointer;
    &:hover {
      background-color: #f5f7fa;
    }
    &.on {
      color: #50bbe5;
    }
  }
}
.popover-fade-enter-active,
.popover-fade-leave-active {
  transition: opacity 0.5s;
}
.popover-fade-enter,
.popover-fade-leave-to {
  opacity: 0;
}
</style>
